module.exports = __webpack_public_path__ + "img/sample_creative_02@1.5x.dff57934.jpg";